import { z } from 'zod';
import { payableDataSchema } from '../../Payable.js';
import { externalFeesServiceConfigSchema } from '../configurations/ExternalFeesServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderExternalFeesDataSchema = servicesProviderGenericDataSchema
    .merge(payableDataSchema)
    .extend({
    config: z.object({
        [Services.EXTERNAL_FEES]: externalFeesServiceConfigSchema,
    }),
}); // this needs to go to a 3rd party vendor OR dealer sometimes

export { servicesProviderExternalFeesDataSchema };
//# sourceMappingURL=ServicesProviderExternalFeesData.js.map
